import { Modal as AntModal } from 'antd';
import type { ComponentProps } from 'react';

type ModalProps = ComponentProps<typeof AntModal> & {
  visible?: boolean;
};

const Modal = ({ visible, open, ...props }: ModalProps) => (
  <AntModal {...props} open={open === undefined ? visible : open} />
);

export default Modal;
